import { create } from 'zustand';
import { Note } from '../../@types/notes-transcription';

interface VoiceNotesState {
  activeTranscriptionChannelId: string | null;
  setActiveTranscriptionChannelId: (
    activeTranscriptionChannelId: string | null,
  ) => void;
  activeTranscriptionOwner: string | undefined;
  setActiveTranscriptionOwner: (
    activeTranscriptionOwner: string | undefined,
  ) => void;
  activeTranscriptionNote: Note | null;
  setActiveTranscriptionNote: (activeTranscriptionNote: Note | null) => void;
  note: Note | null;
  setNote: (note: Note | null) => void;
  notesList: Record<string, Note>;
  addNoteToList: (note: Note) => void;
  openNote: (note: Note) => void;
  closeNote: (note: Note) => void;
  summarized: string[];
  setSummarized: (noteId: string) => void;
}

export const voiceNotesState = create<VoiceNotesState>((set, get) => ({
  activeTranscriptionChannelId: null,
  setActiveTranscriptionChannelId: (activeTranscriptionChannelId) =>
    set({ activeTranscriptionChannelId }),
  activeTranscriptionOwner: undefined,
  setActiveTranscriptionOwner: (activeTranscriptionOwner) =>
    set({ activeTranscriptionOwner }),
  activeTranscriptionNote: null,
  setActiveTranscriptionNote: (activeTranscriptionNote: Note | null) =>
    set({ activeTranscriptionNote }),
  note: null,
  setNote: (note: Note | null) => set({ note }),
  notesList: {},
  addNoteToList: (note) => {
    const { notesList } = get();
    set({
      notesList: {
        ...notesList,
        [note?._id]: note,
      },
    });
  },
  openNote: (note) => {
    get().addNoteToList(note);
    get().setNote(note);
  },
  closeNote: (note) => {
    const { notesList } = get();
    delete notesList[note._id];
    set({ notesList });
  },
  summarized: [],
  setSummarized: (noteId) => set({ summarized: [...get().summarized, noteId] }),
}));

export const useTranscriptionsState = voiceNotesState;
